module.exports = __webpack_public_path__ + "img/icon6.44ed465.png";